import { jsx as i } from "react/jsx-runtime";
import { forwardRef as o } from "react";
import l from "clsx";
import a from "./title.module.css.js";
const T = o(function({ className: t, size: e, as: c, text: n, uppercase: m, ...s }, p) {
  const f = c || "h2", g = Number(String(e || c).replace(/^h([1-6])$/i, "$1")) || 1, u = l(
    a.title,
    a[e === "body" ? e : `size${Math.max(1, Math.min(6, g))}`],
    m && a.uppercase,
    t
  );
  return n && !s.children && Object.assign(s, { children: $(n) }), /* @__PURE__ */ i(f, { className: u, ref: p, ...s });
}), d = o(function(t, e) {
  return /* @__PURE__ */ i(
    h,
    {
      as: "span",
      ref: e,
      size: "6",
      uppercase: !0,
      ...t,
      className: l(a.tagline, t.clasName)
    }
  );
}), h = Object.assign(T, { Tagline: d }), $ = (r) => r.replace(/--/g, "­").replace(/__/g, " ").replace(/(\d)\s(\d)/g, "$1 $2");
export {
  h as Title
};
//# sourceMappingURL=title.js.map
